export default __webpack_public_path__ + "static/media/bishop_white.8333f40f.svg";